import type { TowerType } from "@mmotdg/shared";
import * as THREE from "three";
import type { TowerModelView } from "./types.js";

export const TOWER_COLORS: Record<TowerType, number> = {
  archer: 0x8a6fff,
  cannon: 0xc0703c,
  frost: 0x6ee7ff,
  lightning: 0xfff37a,
  poison: 0x7adc6e,
  support: 0xff8ad8,
  antiair: 0xff5e6b,
  economy: 0xf7c948,
};

export function buildBase(): THREE.Mesh {
  const geo = new THREE.CylinderGeometry(0.45, 0.5, 0.2, 8);
  const mat = new THREE.MeshStandardMaterial({ color: 0x2a3346 });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.position.y = 0.1;
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  return mesh;
}

export function buildSelectionRing(): THREE.Mesh {
  const geo = new THREE.RingGeometry(0.55, 0.65, 32);
  geo.rotateX(-Math.PI / 2);
  const mat = new THREE.MeshBasicMaterial({
    color: 0x6ee7ff,
    transparent: true,
    opacity: 0,
    side: THREE.DoubleSide,
  });
  const ring = new THREE.Mesh(geo, mat);
  ring.position.y = 0.05;
  return ring;
}

export function defaultBodyMaterial(type: TowerType): THREE.MeshStandardMaterial {
  const color = TOWER_COLORS[type] ?? 0xffffff;
  return new THREE.MeshStandardMaterial({
    color,
    emissive: color,
    emissiveIntensity: 0.2,
    roughness: 0.4,
    metalness: 0.2,
  });
}

export function applyTowerLevelVisual(view: TowerModelView, level: number): void {
  view.body.scale.set(1 + level * 0.08, 1 + level * 0.12, 1 + level * 0.08);
  const mat = view.body.material as THREE.MeshStandardMaterial;
  mat.emissiveIntensity = 0.2 + level * 0.15;
}

export function composeView(
  type: TowerType,
  bodyGeometry: THREE.BufferGeometry,
  level: number,
  withSelectionRing: boolean,
): TowerModelView {
  const group = new THREE.Group();
  group.add(buildBase());
  const body = new THREE.Mesh(bodyGeometry, defaultBodyMaterial(type));
  body.position.y = 0.55;
  body.castShadow = true;
  group.add(body);
  const ring = buildSelectionRing();
  if (withSelectionRing) group.add(ring);
  const view: TowerModelView = { group, body, selectionRing: ring };
  applyTowerLevelVisual(view, level);
  return view;
}
